export default "__VITE_ASSET__Dppc99MB__";